var _CUILoader;
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Loader as CUILoader } from "@crehana/ui";
import { jsx as _jsx } from "react/jsx-runtime";
var Loader = function Loader() {
  return /*#__PURE__*/_jsx("div", {
    className: "fixed inset-0 flex items-center justify-center bg-base-main opacity-80",
    style: {
      zIndex: 999999
    },
    children: _CUILoader || (_CUILoader = /*#__PURE__*/_jsx(CUILoader, {
      size: 48
    }))
  });
};
export default Loader;